// Version : 1.0.0
// Author : AGALYA

import { takeLatest, put, all, call } from 'redux-saga/effects';
import SignatureActionType from './signature.types';
import {
	uploadSignatureSuccess,
	uploadSignatureFailure,
	uploadSignatureUserResponseChanged,
} from './signature.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import { signatureUpload } from './signature.service';

/** ***************** upload Signature Start ************************/
export function* UploadSignature({ payload }: any) {
	try {
		const key = 'UploadMemberSignature';
		const { companyID, databaseName, memberID, memberSignature, userID } = payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			MemberID: memberID,
			MemberSignature: memberSignature,
			OfficerID: userID,
			Secratekey: key,
		};

		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(signatureUpload, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(uploadSignatureFailure(responseData.data));
		} else {
			yield put(uploadSignatureSuccess(responseData.data));
		}
	} catch (error) {
		yield put(uploadSignatureFailure(error));
	}
}

export function* UploadSignatureResponseClear() {
	yield put(uploadSignatureUserResponseChanged());
}

export function* onUploadSignatureStart() {
	yield takeLatest(SignatureActionType.UPLOAD_SIGNATURE_START, UploadSignature);
}

export function* onUploadSignatureResponseReset() {
	yield takeLatest(
		SignatureActionType.UPLOAD_SIGNATURE_RESPONSE_REST_START,
		UploadSignatureResponseClear,
	);
}
/** ***************** upload Signature End ************************/

export function* signatureSaga() {
	yield all([call(onUploadSignatureStart), call(onUploadSignatureResponseReset)]);
}
